import { useCallback } from 'react';

import { Input, type InputProps } from '@frontend/components';

type NumberValueFieldProps = Omit<InputProps, 'value' | 'onChange'> & {
  value: string | undefined;
  onChange: (value: string) => void;
  allowDecimals?: boolean;
};

export const NumberValueField = ({
  isDisabled,
  value,
  onChange,
  children,
  allowDecimals = true,
  ...rest
}: NumberValueFieldProps) => {
  const sanitizeInput = useCallback(
    (input: string): string => {
      if (allowDecimals) {
        // Allow digits, decimal point, and minus sign
        return input.replace(/[^0-9.-]/g, '');
      }
      // Only allow digits and minus sign for integers
      return input.replace(/[^0-9-]/g, '');
    },
    [allowDecimals],
  );

  const handleChange = useCallback(
    (val: string) => {
      const sanitized = sanitizeInput(val);
      onChange(sanitized);
    },
    [onChange, sanitizeInput],
  );

  return (
    <Input
      isDisabled={isDisabled}
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      aria-label="Value"
      {...rest}
    />
  );
};
